import React, { useEffect, useState } from 'react';
import { Button } from 'podro-design-system';
import { addIconFilledGrey, shareIcon } from '../../styles/images/icons';
import { useBreakpoints } from '../../utils/customHooks/useBreakpoints';
import logo from '../../styles/images/logo.svg';
import './PWA.scss';

const PWA = () => {
    const { breakpoint } = useBreakpoints();
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(!localStorage.getItem('pwa-screen') && breakpoint === 'xs');
    }, [breakpoint]);

    const handleAddToHomePageClose = () => {
        setShow(false);
        localStorage.setItem("pwa-screen", false)
    }

    return show && (
        <div className='pwa-wrapper'>
            <div className="pwa-logo-box">
                <img src={logo} className="pwa-logo" alt="podro-logo"/>
            </div>
            <p className="pwa-title font-15">نسخه وب اپلیکیشن (PWA) پادرو را به صفحه اصلی اضافه کنید</p>

            <div className="pwa-instructions">
                <div className="pwa-instruction-row row no-gutters justify-content-between">
                    <div className="pt-1 font-14 ">
                        ۱. روی دکمه <span className="pwa-instruction-span">Share</span> در نوار پایین کلیک کنید
                    </div>{shareIcon}
                </div>

                <div className="pwa-instruction-row row no-gutters justify-content-between">
                    <div className="pt-1 font-14 ">
                        ۲. گزینه  <span className="pwa-instruction-span">Add to Home Screen</span> را فعال کنید
                    </div>{addIconFilledGrey}
                </div>

                <div className="pwa-instruction-row row no-gutters justify-content-between">
                    <div className="pt-1 font-14 ">
                        ۳. در قسمت بالا روی <span className="pwa-instruction-span">Add</span> کلیک کنید
                    </div>
                    <div className="font-14 add-icon">Add</div>
                </div>

            </div>
            <Button block onClick={handleAddToHomePageClose}>متوجه شدم!</Button>
        </div>
    );
}

export default PWA;